export default function getLocalRandomQuestion() {
  // 여기서 랜덤으로 문제를 반환하는 로직을 구현합니다.
  const possibleAnswers = [
    ['ㅇ', 'ㅏ', 'ㄴ', 'ㄴ', 'ㅕ', 'ㅇ'],
    ['ㄱ', 'ㅗ', 'ㅏ', 'ㅈ', 'ㅓ', 'ㅣ'],
    ['ㅅ', 'ㅓ', 'ㅇ', 'ㅈ', 'ㅣ', 'ㄹ'],
    ['ㅂ', 'ㅏ', 'ㄴ', 'ㅈ', 'ㅡ', 'ㅇ'],
    ['ㄱ', 'ㅏ', 'ㅣ', 'ㅎ', 'ㅕ', 'ㄱ'],
    ['ㄷ', 'ㅜ', 'ㄴ', 'ㄱ', 'ㅏ', 'ㅂ'],
    ['ㄴ', 'ㅗ', 'ㅇ', 'ㄱ', 'ㅏ', 'ㄴ'],
    ['ㄱ', 'ㅏ', 'ㅈ', 'ㅏ', 'ㅁ', 'ㅣ'],
    ['ㅅ', 'ㅅ', 'ㅏ', 'ㅁ', 'ㅈ', 'ㅣ'],
    ['ㅍ', 'ㅗ', 'ㄷ', 'ㅜ', 'ㅂ', 'ㅜ'],
    ['ㅍ', 'ㅕ', 'ㄴ', 'ㅇ', 'ㅣ', 'ㅂ'],
    ['ㅇ', 'ㅑ', 'ㄱ', 'ㄱ', 'ㅜ', 'ㄱ'],
    ['ㄱ', 'ㅕ', 'ㄹ', 'ㅈ', 'ㅓ', 'ㅇ'],
    ['ㄱ', 'ㅏ', 'ㅂ', 'ㅇ', 'ㅗ', 'ㅅ'],
    ['ㅈ', 'ㅓ', 'ㅇ', 'ㅅ', 'ㅏ', 'ㅇ'],
  ];

  const randomIndex = Math.floor(Math.random() * possibleAnswers.length);
  const randomSolution = possibleAnswers[randomIndex];
  return randomSolution;
}
